import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudType, LoggedInUserModel, prepareGetRequestHttpParams,ResponseMessageTypes, SnackbarService } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { ModulesBasedApiSuffix, PERMISSION_RESTRICTION_ERROR, onActionSubmittedUtil } from '@app/shared/utils';
import { InventoryModuleApiSuffixModels, INVENTORY_COMPONENT } from '@modules/inventory/shared';
import { UserLogin } from '@modules/others/models';
import { Store } from '@ngrx/store';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { handleNgrxStoreData, processStoreData } from '@app/shared/utils/combine-page-level.utils';
@Component({
  selector: 'app-exclution-view',
  templateUrl: './exclution-view.component.html',
  styleUrls: ['./exclution-view.component.scss']
})
export class ExclutionViewComponent extends PrimeNgTableVariablesModel implements OnInit {

  exclusionId: string;
  exclusionDetails: any = [];
  userData: UserLogin;
  searchForm: FormGroup;
  observableResponse: any;
  dataList: any
  status: any = [];
  selectedRows: string[] = [];
  selectedTabIndex: any = 0;
  totalRecords: any;
  pageLimit: number[] = [10, 25, 50, 75, 100];
  loggedInUserData: LoggedInUserModel; 
  primengTableConfigProperties:any;
  columnFilterForm: FormGroup;
  loading: boolean;
  row: any = {};
  first: any = 0;
  reset: boolean;
  namedStackMappingViewDetails;
  constructor(private router: Router, private store: Store<AppState>,private snackbarService:SnackbarService,
    private crudService: CrudService, private formBuilder: FormBuilder,
    private rxjsService: RxjsService, private activatedRoute: ActivatedRoute) {
    super();

    this.exclusionId = this.activatedRoute.snapshot.queryParams.id;
    this.primengTableConfigProperties = {
      tableCaption: "View Exclusion Report",
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Inventory Management', relativeRouterUrl: '' },{ displayName: 'Ordering', relativeRouterUrl: '' } ,{ displayName: 'Exclusion Report', relativeRouterUrl: '/inventory/requisitions/exclusion' },{ displayName: 'View Exclusion Report', relativeRouterUrl: '' }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'View Exclusion Report',
            dataKey: 'cycleCountId',
            enableBreadCrumb: true,
            enableAction: true,
            enableEditActionBtn: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            cursorLinkIndex: 0,
            columns: [{ field: 'stockCode', header: 'Stock Code', width: '180px' },
            { field: 'stockDescription', header: 'Stock Description', width: '200px' },
            { field: 'fixedPricing', header: 'Fixed Pricing', width: '180px' },
            { field: 'condition', header: 'Condition', width: '180px' },
            { field: 'obsolete', header: 'Obsolete', width: '180px' },
            { field: 'procurable', header: 'Procurable', width: '180px' },
            { field: 'quantityOnHand', header: 'Quantity On Hand', width: '180px' },
            { field: 'minimumThreshold', header: 'Min Threshold', width: '180px' },
            { field: 'maximumThreshold', header: 'Max Threshold', width: '180px' },
            { field: 'pendingRequisitionPOQuantity', header: 'Pending Requisition/POs', width: '200px' },
            { field: 'pickingOrderQuantity', header: 'Picking Order Qty', width: '200px' },
            { field: 'maxThresholdRefillQuantity', header: 'Max Threshold Refill Qty', width: '200px' },
            { field: 'orderQuantityMaxThreshold', header: 'Order Qty > Max Threshold', width: '210px' },
            { field: 'requestedQuantity', header: 'Requsted Qty', width: '150px' },
            { field: 'comments', header: 'Comments', width: '150px',isparagraph:true }], 
            isDateWithTimeRequired: true,
            apiSuffixModel: InventoryModuleApiSuffixModels.EXCLUSION_LIST_DETAILS,
            moduleName: ModulesBasedApiSuffix.INVENTORY,
      }
        ]
      }
    }
    this.searchForm = this.formBuilder.group({ searchKeyword: "" });
    this.columnFilterForm = this.formBuilder.group({});

    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.selectedTabIndex = (Object.keys(params['params']).length > 0) ? params['params']['tab'] ? +params['params']['tab'] : 0 : 0;
      this.primengTableConfigProperties.selectedTabIndex = this.selectedTabIndex;
    //  this.primengTableConfigProperties.breadCrumbItems[1].displayName = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption;
    });
  }

  ngOnInit() {
    handleNgrxStoreData((response) => {
      let processData = processStoreData(response, this.primengTableConfigProperties, INVENTORY_COMPONENT.EXCLUSION_LIST);
      this.primengTableConfigProperties = processData.primengTableConfigProperties
      this.loggedInUserData = processData.loggedInUserData
    }, this.store);
    this.getRequiredListData();
  }

  getRequiredListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    otherParams = {...otherParams,...{exclusionListId: this.exclusionId}}
    this.loading = true;      
    let InventoryModuleApiSuffixModels: InventoryModuleApiSuffixModels;
    InventoryModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels,
      undefined, false, 
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe(data => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.observableResponse = data.resources.items;
        this.dataList = this.observableResponse;
        this.totalRecords = data.resources.totalCount;
        this.exclusionDetails = data.resources;
        this.onShowValue();
      } else {
        this.observableResponse = null;
        this.dataList = this.observableResponse
        this.totalRecords = data.resources.totalCount;
      }
    });
  }
  onShowValue() {
    this.namedStackMappingViewDetails = [
      { name: 'Exclusion ID', value: this.exclusionDetails?.exclusionListNumber },
      { name: 'Generated Date', value: this.exclusionDetails?.createdDate },
      { name: 'Warehouse', value: this.exclusionDetails?.warehouseName },
    ]
  }
  navigateToEdit(){
    if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
     }
    this.router.navigate(['/inventory/requisitions/exclusion/update'], {
      queryParams: {
        id: this.exclusionId,
      }, skipLocationChange: true
    });
  }

  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: any): void {
    switch (type) {
      case CrudType.EDIT:
        // this.openAddEditPage(CrudType.EDIT, row);
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
         }
        this.navigateToEdit();
        break;
        case CrudType.GET:
          unknownVar = {...unknownVar,...{ UserId: this.loggedInUserData?.userId}};
          this.getRequiredListData(row["pageIndex"],row["pageSize"], unknownVar)
          break;
      default:
    }
  }
  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }
}
